// Module
var code = `<template>
  <require from="./portfolio-period-widget.scss"></require>
  <require from="../../../converters/column-widths-converter"></require>

  <div class="portfolio-period-widget portfolio-period-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .portfolio-period-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .portfolio-period-widget-\${id} td {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .portfolio-period-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th style="\${columnWidths | columnWidths:0}">Name</th>
          <th style="\${columnWidths | columnWidths:1}" class="widget-table__numeric">Value IB</th>
          <th style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">Invested capital</th>
          <th style="\${columnWidths | columnWidths:3}" class="widget-table__numeric">Sale</th>
          <th style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">Realized P&L</th>
          <th style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">Unrealized P&L</th>
          <th style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">Value UB</th>
          <th style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">Cost price IB</th>
          <th style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">Cost price UB</th>
        </tr>
      </thead>
      <tbody>
        <template repeat.for="v of instrumentValues">
          <tr class="\${v === total ? 'widget-table__total' : ''} \${v.group1Total ? 'widget-table__group-total' : ''} \${v.group1Header ? 'widget-table__group-header' : ''}">
            <td style="\${columnWidths | columnWidths:0}; padding-left: \${v.indent}px">
              \${v.name}
            </td>

            <template if.bind="!groupHeader">

              <td style="\${columnWidths | columnWidths:1}" class="widget-table__numeric">
                \${v.estimatedValueOpeningBalancePeriod | numericFormatter:quantityPrecision}
              </td>

              <td style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">
                \${v.costOfAcquiredChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:3}" class="widget-table__numeric">
                \${v.realizedChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">
                \${v.realizedProfitLossChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
                \${v.unrealizedProfitLossChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
                \${v.estimatedValueClosingBalance | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
                \${v.costPriceOpeningBalancePeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
                \${v.costPriceClosingBalance | numericFormatter:precision}
                <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
              </td>

            </template>
          </tr>
        </template>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;